import propsflow from "propsflow"
import EnhanceRedux from "../EnhanceRedux"

export default domain =>
  propsflow(
    EnhanceRedux(
      {
        [domain.name]: domain.reducer,
      },
      false,
      domain.enhancer,
    ),
    () => props => {
      const { store } = props
      if (domain.saga) {
        store.runReduxSaga(domain.saga)
      }
    },
  )
